import { useSelector } from "react-redux";
import { UserIconFill } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import { isPermit } from "utils/permissionCheck";
import style from "../../ward_details.module.scss";

function ProfileCard({ setOpen = () => {} }) {
  const { selectedUser } = useSelector((state) => state.wards);

  return (
    <div className={style["profile-card"]}>
      <div className="flex align-center justify-between gap-3">
        <div className="flex align-center gap-2">
          <span className="">
            <UserIconFill />
          </span>
          <h6 className={style["section-title"]}>Active Councillor</h6>
        </div>
        {isPermit(5, "edit") && (
          <ButtonComp onClick={() => setOpen(true)}>Change</ButtonComp>
        )}{" "}
      </div>
      <div className="flex align-center">
        <div className="flex mr-24">
          {selectedUser?.councilor_image ? (
            <AvatarComp size={74} blue src={selectedUser?.councilor_image} />
          ) : (
            <AvatarComp size={72} blue>
              {selectedUser?.councillor?.replace(" ", "")?.charAt(0)}
            </AvatarComp>
          )}
        </div>
        <div className="flex flex-column gap-0_5">
          <h2 className="page-title">{selectedUser?.councillor}</h2>
          <div className="flex gap-40 mt-10 justify-between">
            <div className="">
              <p className={style["label"]}>Term</p>
              <p className={style["label-value"]}>{selectedUser?.term}</p>
            </div>
            <div>
              <p className={style["label"]}>Phone Number</p>
              <p className={style["label-value"]}>
                {selectedUser?.phone_number}
              </p>
            </div>
            <div>
              <p className={style["label"]}>Email Address</p>
              <p className={style["label-value"]}>{selectedUser?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileCard;
